import { isDevOrStagging } from './env';

export const getServiceUrl = () => {
  if (isDevOrStagging) {
    return 'https://staging.kripton.la';
  }

  return 'https://kripton.la';
};

export const getServicesAppUrl = () => {
  if (isDevOrStagging) {
    return 'https://staging.kripton.la/services';
  }

  return 'https://kripton.la/services';
};

export const getMapUrl = () => {
  if (isDevOrStagging) {
    return 'https://staging-map.kriptonmarket.com';
  }

  return 'https://map.kriptonmarket.com';
};

export const getLandingUrl = () => {
  if (isDevOrStagging) {
    return 'https://staging-info.kriptonmarket.com';
  }

  return 'https://info.kriptonmarket.com';
};

export const getAuthLoginUrl = () => {
  const { pathname, search } = window.location;

  return `${getServiceUrl()}/auth?redirect=${pathname}${search}`;
};
